var Intesa = Intesa || {};

/**
 * Intesa loan calculator PBZ
 *
 */
Intesa.appleBusinessWidget = function() {
	
	var appleBusinessWidget = this;
	
	this.init = function(){
	try {
		var isPbz = $("html").attr("data-bank") == "PBZ";
		if(isPbz){
		var platform = appleBusinessWidget.iOS();
		var isMac = navigator.platform.toUpperCase().indexOf('MAC')>=0;
		var isSupported = window.appleBusinessChat.isSupported();
		var isRetail = $("#isRetail").length > 0 ? $("#isRetail").val().toString() : null;
		console.log("isSupported:",isSupported);
		console.log("isRetail:",isRetail);

		if(isPbz && $('.abcw-component').length == 0 && (platform == true ) && isRetail == "true"){
			$("#appleChatFloating").removeClass("hide");
		}else if (isPbz && $('.abcw-component').length > 0 && (platform == true) && isRetail == "true"){
			if(isSupported){
				$('a[title="Chat"]').parent()[0].style.display = "none";
			}else{
				console.log("not supported");
			}
		}

		if($('.abcw-component').length > 0){
			if(isMac){
				document.querySelector('.abcw-component').style.visibility = "hidden";
				document.querySelector('.apple-business-chat-fallback-container').style.visibility = "visible";
			}
		}	
		}
		}catch(error){
			console.log("error-> ",error);
		}
			
	}

	this.iOS = function() {
		  return [
		    'iPad Simulator',
		    'iPhone Simulator',
		    'iPod Simulator',
		    'iPad',
		    'iPhone',
		    'iPod'
		  ].includes(navigator.platform)
		  // iPad on iOS 13 detection
		  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
	}
	
}

Intesa.appleBusinessWidget.getInstance = function() {

	if( !window.intesa ) {

		window.intesa = new Object();

    }

	if( !window.intesa.apple_business_widget ) {

		window.intesa.apple_business_widget= new Intesa.appleBusinessWidget();

	}

	return window.intesa.apple_business_widget;

};



